module.exports = __webpack_public_path__ + "img/bd(5).a3185642.png";